import { render, staticRenderFns } from "./CatalogOtcFilters.vue?vue&type=template&id=2629baa8&scoped=true"
import script from "./CatalogOtcFilters.vue?vue&type=script&lang=js"
export * from "./CatalogOtcFilters.vue?vue&type=script&lang=js"
import style0 from "./CatalogOtcFilters.vue?vue&type=style&index=0&id=2629baa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2629baa8",
  null
  
)

export default component.exports